import { useState } from "react";
import { Link } from "react-router-dom";
import api, { apiErr } from "@/lib/api";
import { Leaf, Loader2, ArrowLeft, MailCheck } from "lucide-react";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
      setDone(true);
    } catch (err) {
      toast.error(apiErr(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-stone-50 px-6">
      <div className="w-full max-w-sm animate-fade-up">
        <div className="mb-8 flex items-center gap-2.5">
          <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-emerald-600">
            <Leaf className="h-5 w-5 text-white" />
          </div>
          <span className="font-heading text-lg font-semibold">Yoga Day Studio</span>
        </div>

        {done ? (
          <div className="text-center" data-testid="forgot-success">
            <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-emerald-100">
              <MailCheck className="h-6 w-6 text-emerald-700" />
            </div>
            <h2 className="mt-4 font-heading text-2xl font-semibold text-stone-900">Check your inbox</h2>
            <p className="mt-2 text-stone-500">
              If an account exists for <strong>{email}</strong>, a password reset link has been generated.
              Please contact your administrator if you don't receive it.
            </p>
            <Link to="/login" className="mt-6 inline-flex items-center gap-2 text-sm font-medium text-emerald-700">
              <ArrowLeft className="h-4 w-4" /> Back to sign in
            </Link>
          </div>
        ) : (
          <>
            <h2 className="font-heading text-3xl font-semibold text-stone-900">Reset password</h2>
            <p className="mt-2 text-stone-500">Enter your email and we'll generate a reset link.</p>
            <form onSubmit={submit} className="mt-8 space-y-5">
              <div>
                <label className="text-xs font-bold uppercase tracking-[0.15em] text-stone-500">Email</label>
                <input
                  data-testid="forgot-email-input"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="mt-2 flex h-11 w-full rounded-md border border-stone-300 bg-white px-3 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500"
                  placeholder="you@bluecross.com"
                />
              </div>
              <button
                type="submit"
                disabled={loading}
                data-testid="forgot-submit-button"
                className="inline-flex h-11 w-full items-center justify-center rounded-md bg-emerald-600 text-sm font-semibold text-white hover:bg-emerald-700 disabled:opacity-60"
              >
                {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Send reset link"}
              </button>
              <Link to="/login" className="flex items-center justify-center gap-2 text-sm font-medium text-stone-500 hover:text-stone-700">
                <ArrowLeft className="h-4 w-4" /> Back to sign in
              </Link>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
